export default __webpack_public_path__ + "static/node-d35e8415bae2ad0807733a2b8a6afea4.png";